<template>
    
</template>

<script>
    import PreviewFooterSection from "../footer/PreviewFooterSection";
    import SchoolFooterSection from "../../../components/pagesbuilder/sections/SchoolFooterSection";
    export default {
        name: "PreviewSchoolFooterSection",
        mixins: [PreviewFooterSection, SchoolFooterSection],
    }
</script>

